import { defineComponent as _defineComponent } from 'vue'
import { PaginatedParams, PaymentState } from 'ah-api-gateways';
import WalletIcon from '@/app/icons/svgs/WalletIcon.vue';
import PaymentListing from 'ah-payments/src/components/PaymentListing.vue';
import { useAuthStore } from '@/app/store/authStore';
import { upcomingPaymentsTableFields } from './tableFields/upcomingPaymentsTableFields';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentsDashboardWidget',
  setup(__props) {

const authStore = useAuthStore();

const upcomingPaymentsFilters = {
  state: [PaymentState.PENDING, PaymentState.QUEUED, PaymentState.SCHEDULED],
  excludeClients: !authStore.isClientUser,
  excludePartners: authStore.isClientUser,
  ...(authStore.isClientUser
    ? { clientId: authStore.loggedInIdentity?.client?.id }
    : { partnerId: authStore.loggedInIdentity?.partner.id }),
};

const upcomingPaymentsConfig = {
  tableFields: upcomingPaymentsTableFields,
};

const upcomingPaymentsSortAndPageParams: Partial<PaginatedParams> = {
  sort: 'executionDate',
  sortDirection: 'ASC',
  pageSize: 5,
};

return { __sfc: true,authStore, upcomingPaymentsFilters, upcomingPaymentsConfig, upcomingPaymentsSortAndPageParams, WalletIcon, PaymentListing }
}

})